import { normalizeMimeType } from './normalizeMimeType';

export const buildDataImageUri = (data?: string, type?: string) => {
  const trimmedData = data?.trim();

  if (!trimmedData) {
    return null;
  }

  if (trimmedData.startsWith('data:')) {
    return trimmedData;
  }

  const mimeType = normalizeMimeType(type);

  if (!mimeType) {
    return null;
  }

  return `data:${mimeType};base64,${trimmedData}`;
};
